import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import SbusPage from './pages/SbusPage';
import WhoWeArePage from './pages/WhoWeArePage';
import MissionVisionPage from './pages/MissionVisionPage';
import PartnershipsPage from './pages/PartnershipsPage';
import LeadersTeamPage from './pages/LeadersTeamPage';
import AgronomyPage from './pages/AgronomyPage';
import SeedProductionIrrigationPage from './pages/SeedProductionIrrigationPage';
import CommercialFarmingPage from './pages/CommercialFarmingPage';
import ValueAdditionPage from './pages/ValueAdditionPage';
import TradingPage from './pages/TradingPage';
import OperationsOrganizationPage from './pages/OperationsOrganizationPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/sbus" element={<SbusPage />} />
        <Route path="/who-we-are" element={<WhoWeArePage />} />
        <Route path="/mission-vision" element={<MissionVisionPage />} />
        <Route path="/partnerships" element={<PartnershipsPage />} />
        <Route path="/leaders-team" element={<LeadersTeamPage />} />
        <Route path="/agronomy" element={<AgronomyPage />} />
        <Route path="/seed-production-irrigation" element={<SeedProductionIrrigationPage />} />
        <Route path="/commercial-farming" element={<CommercialFarmingPage />} />
        <Route path="/value-addition" element={<ValueAdditionPage />} />
        <Route path="/trading" element={<TradingPage />} />
        <Route path="/operations-organization" element={<OperationsOrganizationPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </div>
  );
}

export default App;
